import { render, staticRenderFns } from "./LayoutToolbar.vue?vue&type=template&id=85604e60&"
import script from "./LayoutToolbar.vue?vue&type=script&lang=ts&"
export * from "./LayoutToolbar.vue?vue&type=script&lang=ts&"
import style0 from "./LayoutToolbar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex})
